// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__8EDH1","content":"styles_content__PYC2y","icon":"styles_icon__cWAlL"};